/**
 * Define App configuration variables
 *
 * API + images are RELATIVE so the app works on any host/scheme (IP, tunnel, or domain).
 * The ONLY absolute URL is the customer-facing site, used to build QR codes. It comes from
 * a single build-time env var so switching domains is one change:
 *
 *   react/owner/.env →  REACT_APP_CUSTOMER_URL=https://your-domain.com
 *   then: npm run build
 */
const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL || 'http://187.124.183.33';

const config = {
    appName: 'CometQR',
    appTitle: 'CometQR',
    tagLine: 'Online Menu',
    currencySymbol: '€',
    supportEmail: 'support@cometqr.com',
    environment: 'development', // development/production
    production: {
        api_url: '/api/',
        app_url: CUSTOMER_SITE_URL,
    },
    development: {
        api_url: '/api/',
        app_url: CUSTOMER_SITE_URL, // QR-code target = the customer site
    },
};

export default config;
